import React, { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';
import './AuthThemeSwitcher.css';

export const getInitialAuthTheme = () => {
  const saved = localStorage.getItem('auth_theme');
  if (saved === 'light' || saved === 'dark') {
    return saved;
  }
  if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
};

export const useAuthTheme = () => {
  const [theme, setTheme] = useState(getInitialAuthTheme);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      // Only auto-update if the user hasn't explicitly chosen a theme preference
      if (!localStorage.getItem('auth_theme')) {
        setTheme(e.matches ? 'dark' : 'light');
      }
    };

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange);
      } else if (mediaQuery.removeListener) {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  const toggleTheme = () => {
    const nextTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(nextTheme);
    localStorage.setItem('auth_theme', nextTheme);
  };

  return { theme, toggleTheme };
};

export const AuthThemeSwitcher = ({ theme, toggleTheme }) => {
  return (
    <button
      type="button"
      className={`auth-theme-toggle ${theme}`}
      onClick={toggleTheme}
      title={`Switch to ${theme === 'dark' ? 'Light' : 'Dark'} mode`}
      aria-label={`Switch to ${theme === 'dark' ? 'Light' : 'Dark'} mode`}
    >
      {theme === 'dark' ? (
        <>
          <Sun size={18} className="theme-icon sun-icon" />
          <span className="theme-text">Light</span>
        </>
      ) : (
        <>
          <Moon size={18} className="theme-icon moon-icon" />
          <span className="theme-text">Dark</span>
        </>
      )}
    </button>
  );
};
